module.exports = __webpack_public_path__ + "static/img/icon_messages@2x.c9ebbb80.png";